import download from 'downloadjs';
import { SERVER_URL } from '../../../config';

const handleDownload = async ({ cycleId, notify }) => {
  try {
    const response = await fetch(`${SERVER_URL}/orders/generate/xml`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({ id: Number(cycleId) }),
    });

    if (response.status !== 200){
      const error = await response.json();
      throw new Error(error.message);
    }

    const blob = await response.blob();

    download(blob, `orders-by-cycle-${cycleId}.zip`);
  } catch (error) {
    console.log(error);
    notify(`Error: ${error.message}`, { type: 'warning' });
  }
};

export default handleDownload;
